import React from 'react';
import {
  Container,
  Grid,
  Stack,
  Text,
  Title,
  Image,
  List,
  ThemeIcon,
  rem,
  Group,
  Box,
  AspectRatio,
  SimpleGrid,
} from '@mantine/core';
import { useEffect, useState } from 'react';
import { set } from 'lodash';
import { useViewportSize } from '@mantine/hooks';
import GoogleMap from '../../Components/map_react';
import { Animate } from 'react-simple-animate';
import { FaCheck } from 'react-icons/fa';
import parse from 'html-react-parser';

/**
 * This view component will be rendered when visiting /pages/greet
 * when your application has been setup with inertiajs.
 */
export default function Details(props) {
  const [images, setImages] = useState(null);
  const [image_blocks, setImageBlocks] = useState(null);
  const { height, width } = useViewportSize();
  const tour = props.tour.tour;
  const quote = props.tour;
  useEffect(() => {
    fetch('/tours/getImages/' + tour.id)
      .then((res) => res.json())
      .then(
        (result) => {
          setImages(result);
          var images = result.map((image, index) => (
            <Grid.Col
              pt={0}
              px={0}
              key={image.day_image}
              span={index == 0 ? 12 : 3}
            >
              <Container pt={0} px={10}>
                <AspectRatio
                  ratio={index == 0 ? 10 / 8 : 4 / 4}
                  visibleFrom={index == 0 ? '' : 'md'}
                  maw={'100%'}
                >
                  <Image
                    src={`https://www.best-scottish-tours.co.uk/Plugin/Tours/assets/image/large_${image.day_image}`}
                    alt='Random unsplash image'
                  />
                </AspectRatio>
              </Container>
            </Grid.Col>
          ));
          setImageBlocks(images);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {}
      );
  }, []);
  console.log(tour);
  return (
    <Animate
      play={true}
      start={{
        transform: 'translateX(-100px)',
        opacity: 0.1,
      }}
      end={{ transform: 'translateX(0px)', opacity: 1 }}
      easeType='ease-in'
      duration={0.3}
      delay={0}
    >
      <Grid>
        <Grid.Col span={{ base: 12, md: 5 }} p={0}>
          <Container p={0}>
            <Grid p={0}>{image_blocks}</Grid>
          </Container>
        </Grid.Col>
        <Grid.Col h={(height - 163) / 2} span={{ base: 12, md: 7 }}>
          <Stack>
            <Container pt={50}>
              <Title fz={rem(40)}>{quote.name}</Title>
              <Text size='xl'>{tour.nights + 1} Day Grand Tour</Text>
              <Text c='#4099BE' size='lg' fw={600}>
                £{quote.price} per person | 23rd June - 3rd July
              </Text>
              <Text c='#B54937' fw={700}>
                Pickup: {quote.pickup} | Drop Off: {quote.drop_off}
              </Text>
              <Text c='#000000' fw={700}>
                Pre Tour Hotel: {quote.pre_hotel} | Post Tour Hotel:{' '}
                {quote.post_hotel}
              </Text>
              <Group pt={30}>
                <Text
                  w={'100%'}
                  style={{ columns: 2, overflow: 'hidden' }}
                  h={(height - 163) / 2 / 2 / 2}
                  c={'black'}
                >
                  {quote.summary.replace(/<[^>]+>/g, '')}
                </Text>
              </Group>
            </Container>
            <Container pl={0} fluid m={0}>
              <Grid h={(height - 163) / 2}>
                <Grid.Col span={{ base: 12, md: 6 }} bg={'grey.0'} p={0}>
                  <Container
                    p={50}
                    fluid
                    style={{
                      overflowY: 'scroll',
                      maxHeight: '100%',
                    }}
                  >
                    <Title style={{ fontWeight: 400 }} order={3}>
                      What's Included
                    </Title>
                    <div className='whats-included'>
                      {parse(quote.whats_included)}
                    </div>
                  </Container>
                </Grid.Col>
                <Grid.Col
                  // h={(height - 163) / 2}
                  p={0}
                  span={{ base: 12, md: 6 }}
                >
                  <Container
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    fluid
                    p={0}
                  >
                    <GoogleMap tour={tour.tour_days}></GoogleMap>
                  </Container>
                </Grid.Col>
              </Grid>
            </Container>
          </Stack>
        </Grid.Col>
      </Grid>
    </Animate>
  );
}
